import React, {Component} from "react";
import Provider from "pubsub-js";
import {
  SELECTION_CREATED,
  SELECTION_CLEARED,
  SELECTION_UPDATED,
  OBJECT_REMOVED
} from "../constants/event-types";

export default (OriginalComponent) =>
  class SelectionContextComponent extends Component {
    state = {
      selected: null
    };
    onSelectionCreated = (_, selected) => {
      this.setState({
        selected
      });
    };
    onSelectionUpdated = (_, {selected}) => {
      this.onSelectionCreated(_, selected[0]);
    };
    onSelectionCleared = () => {
      this.setState({
        selected: null
      });
    };
    componentDidMount() {
      Provider.subscribe(SELECTION_CREATED, this.onSelectionCreated);
      Provider.subscribe(SELECTION_UPDATED, this.onSelectionUpdated);
      Provider.subscribe(SELECTION_CLEARED, this.onSelectionCleared);
      Provider.subscribe(OBJECT_REMOVED, this.onSelectionCleared);
    }
    componentWillUnmount() {
      Provider.unsubscribe(SELECTION_CREATED, this.onSelectionCreated);
      Provider.unsubscribe(SELECTION_CLEARED, this.onSelectionCleared);
      Provider.unsubscribe(SELECTION_UPDATED, this.onSelectionUpdated);
      Provider.unsubscribe(OBJECT_REMOVED, this.onSelectionCleared);
    }
    render() {
      return <OriginalComponent {...this.props} {...this.state} />;
    }
  };
